import { jsx as _jsx } from "react/jsx-runtime";
import { ApprovalItem } from '@src/components/Manager/ApprovalItem';
import { useParams } from 'react-router-dom';
export const ApprovalTask = () => {
    const { id } = useParams();
    return _jsx(ApprovalItem, { id: Number(id) });
};
